import SEO from '../components/SEO';
import DeveloperToolsPanel from '../components/DeveloperToolsPanel';

export default function UUIDGeneratorPage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "UUID Generator - JsonToonCraft",
    "applicationCategory": "DeveloperApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": "Free UUID generator tool. Generate random v4 UUIDs (Universally Unique Identifiers) for your applications.",
    "featureList": [
      "UUID v4 generation",
      "Bulk UUID generation",
      "Instant generation",
      "Offline support",
      "Copy to clipboard",
      "No limits"
    ]
  };

  return (
    <>
      <SEO
        title="UUID Generator - Generate Random UUIDs Online | JsonToonCraft"
        description="Free UUID generator tool. Generate random v4 UUIDs (Universally Unique Identifiers) for your applications. Bulk generation supported. Works offline."
        keywords="UUID generator, GUID generator, generate UUID, random UUID, UUID v4, unique identifier generator"
        canonicalUrl="https://jsontooncraft.com/dev-tools/uuid-generator"
        structuredData={structuredData}
      />

      <DeveloperToolsPanel initialTool="uuid" />
    </>
  );
}
